import { render, staticRenderFns } from "./reportcase-manage-resolve.vue?vue&type=template&id=f22d3740&scoped=true"
import script from "./reportcase-manage-resolve.vue?vue&type=script&lang=ts"
export * from "./reportcase-manage-resolve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22d3740",
  null
  
)

export default component.exports